<template>
  <div>
    <v-dialog transition="scroll-x-transition" max-width="450" v-model="dialog">
      <template v-slot:activator="{ on, attrs }">
        <v-btn dark color="bolsa-guinda" v-bind="attrs" v-on="on"
          >Cambiar Mi Contraseña<v-icon right>mdi-key</v-icon></v-btn
        >
      </template>
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="#3c4b64" dark
            >Creación de Nueva Contraseña</v-toolbar
          >
          <v-card-text class="pb-0">
            <div class="text-subtitle-2 pt-4">
              Por favor, ingresa tu contraseña actual y a continuación, tu nueva
              contraseña
            </div>
            <v-form ref="formNuevoPassword">
              <v-container class="px-0">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      label="Contraseña Actual"
                      required
                      outlined
                      dense
                      solo
                      v-model="password.antiguaPassword"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      label="Nueva Contraseña"
                      required
                      outlined
                      dense
                      solo
                      v-model="password.nuevaPassword"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn
              color="bolsa-green"
              class="ma-2 mx-2"
              :loading="fetching"
              :disabled="fetching"
              :dark="!fetching"
              @click="changePassword"
              >Cambiar Contraseña<v-icon right>mdi-lock-check</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      password: {
        nuevaPassword: "",
        antiguaPassword: ""
      }
    };
  },

  computed: {
    ...mapGetters("user", ["fetching"])
  },

  methods: {
    ...mapActions("admin", ["fetchUpdateAdminPassword"]),

    async changePassword() {
      let response = await this.fetchUpdateAdminPassword(this.password);
      if (response) {
        this.dialog = false;
        this.password = {
          nuevaPassword: "",
          antiguaPassword: ""
        };
      }
    }
  }
};
</script>

<style>
</style>